import { COL_OFFSET } from '@/domain/mitarbeiter/features/rotationsplan/constants';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderArbeitsbereich';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { KalenderMitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderMitarbeiter';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

class KalenderStation {
  constructor({ station }: { station: ArbeitsbereichStation }) {
    this.station = station;
  }

  station: ArbeitsbereichStation;

  getColStart(displayYear: number): number {
    const gridStart = dayjs().year(displayYear).isoWeek(1).startOf('isoWeek');

    if (dayjs(this.station.von).isBefore(gridStart)) {
      return COL_OFFSET + 1;
    }

    const daysSinceGridStart = dayjs(this.station.von).diff(gridStart, 'day');
    return daysSinceGridStart + COL_OFFSET + 1;
  }

  getColEnd(displayYear: number): number {
    const gridStart = dayjs().year(displayYear).isoWeek(1).startOf('isoWeek');
    const displayDaysOfYear = dayjs().year(displayYear).isoWeeksInYear() * 7;
    const daysSinceGridStart = dayjs(this.station.bis).diff(gridStart, 'day');

    if (daysSinceGridStart >= displayDaysOfYear) {
      return displayDaysOfYear + COL_OFFSET + 1;
    }

    return daysSinceGridStart + COL_OFFSET + 2;
  }
}

export class KalenderStationByArbeitsbereich extends KalenderStation {
  constructor({
    station,
    mitarbeiter,
  }: {
    station: ArbeitsbereichStation;
    mitarbeiter: KalenderMitarbeiter[];
  }) {
    super({ station });
    this.mitarbeiter = mitarbeiter;
  }

  mitarbeiter: KalenderMitarbeiter[];
}

export class KalenderStationByMitarbeiter extends KalenderStation {
  constructor({
    station,
    arbeitsbereich,
  }: {
    arbeitsbereich: KalenderArbeitsbereich;
    station: ArbeitsbereichStation;
  }) {
    super({ station });
    this.arbeitsbereich = arbeitsbereich;
  }

  arbeitsbereich: KalenderArbeitsbereich;
}
